// Quick-chip semantics on the shared filter state (the same object the filter sheet edits); no DOM, no imports.
// The power chips are presets of the one power range (min < max): "from 150" sets the lower bound, "up to 22" the upper bound.
// A range cannot satisfy both, so switching one on clears a bound that would make it empty.
export const POWER_FROM = 150, POWER_TO = 22;
export const chipState = f => ({from: f.min === POWER_FROM, to: f.max === POWER_TO, free: f.onlyFree});
export function toggleChip(f, id) {
  if (id === 'from') {
    if (f.min === POWER_FROM) f.min = 0;
    else { f.min = POWER_FROM; if (f.max <= POWER_FROM) f.max = Infinity; }
  } else if (id === 'to') {
    if (f.max === POWER_TO) f.max = Infinity;
    else { f.max = POWER_TO; if (f.min >= POWER_TO) f.min = 0; }
  } else if (id === 'free') f.onlyFree = !f.onlyFree;
}
